import { DividerProps } from './props';
import styles from './styles.module.scss';

export default function Divider({ secondary }: DividerProps) {
  return (
    <div
      className={`${styles.container} ${secondary ? styles['container--secondary'] : ''}`}
    >
      <div className={styles.container__line} />
    </div>
  );
}
